import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { oli_products_get, oli_product_users_get_with_project_data } from "../services/apiService";
import { useAuth } from '../hooks/AuthContext';
import LogoutButton from '../components/LogoutButton';
import xoroLogo from "../assects/img/X_logo.png";

function OliProductSelectionPage() {

  const navigate = useNavigate();
  const { logout, oliLogout } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [projectData, setProjectData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const itemsPerPage = 10;

  const filteredProjects = projectData.filter(
    (product: any) =>
      product.project_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const paginatedProjects = filteredProjects.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleRowClick = (id: any, project_name: string) => {
    localStorage.setItem("oli_product", project_name);
    localStorage.setItem("oli_product_id", String(id));
    navigate(`/OliProductCustomers/?id=${id}`);
  };

  {/* async function getAll() {
    setLoading(true);
    const response = await oli_products_get();
    if (response.status != "No users found") {
      setProjectData(response);
    }
    setLoading(false);
  }

  useEffect(() => {
    getAll();
  }, []);
*/}
  async function getAll() {
    setLoading(true);
    try {
      const response = await oli_products_get();
      if (response.status != "No users found") {
        // Fetch customer count for each project
        const projectsWithCounts = await Promise.all(
          response.map(async (project: any) => {
            try {
              const userResponse = await oli_product_users_get_with_project_data(project.id);
              const customerCount = userResponse?.usersDetails?.length || 0;
              return { ...project, customer_count: customerCount };
            } catch (error) {
              console.error(`Error fetching customers for project ${project.id}:`, error);
              return { ...project, customer_count: 0 };
            }
          })
        );
        setProjectData(projectsWithCounts);
      } else {
        setProjectData([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectData([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAll();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-gray-200/60 shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Brand & Title */}
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                <div className="p-2.5 bg-white rounded-xl shadow-lg border border-gray-200/50">
                  <img
                    src={xoroLogo}
                    alt="Avironix Logo"
                    className="w-6 h-6 object-cover rounded-full"
                  />
                </div>
              </div>
              <div>
                <h1 className="text-xl font-semibold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                  OLI
                </h1>
                <p className="text-sm text-gray-500 font-medium">Powered by XORO Story</p>
              </div>
            </div>

            {/* User Info & Actions */}
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {localStorage.getItem('oli_username')}
                </p>
                <p className="text-xs text-blue-600 font-medium">Administrator</p>
              </div>
              {/*  <div className="w-8 h-8 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center ring-2 ring-white">
                <span className="text-xs font-semibold text-gray-700">
                  {localStorage.getItem('oli_username')?.charAt(0)?.toUpperCase() || 'U'}
                </span>
              </div> */}
              <LogoutButton />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header with Actions */}
        <div className="mb-8">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div>
              <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent">
                Products
              </h2>

              <div className="mt-3 flex items-center space-x-2">
                <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                <span className="text-sm text-gray-500">
                  {projectData.length} {projectData.length === 1 ? 'product' : 'products'} available
                </span>
              </div>
            </div>
            <div className="mt-6 sm:mt-0">
              <button
                onClick={() => { window.location.href = '/OliConfigurator'; }}
                className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Open Configurator
              </button>
            </div>
          </div>

          {/* Search Bar */}
          <div className="mt-8">
            <div className="max-w-md">
              <label htmlFor="search" className="sr-only">Search products</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="search"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl leading-5 bg-white/80 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md"
                />
              </div>
            </div>
          </div>
        </div>
        {/*Products Grid */}
        {paginatedProjects.length !== 0 ? (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {paginatedProjects.map((project: any, index: number) => (
              <div
                key={project.id}
                onClick={() => handleRowClick(project.id, project.project_name)}
                className="group relative bg-white/80 backdrop-blur-sm rounded-2xl border border-gray-200/60 p-6 hover:shadow-xl hover:shadow-blue-100/50 hover:border-blue-300/40 transition-all duration-300 cursor-pointer transform hover:-translate-y-1 flex flex-col"
              >
                {/*Background Pattern */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 to-indigo-50/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/*Header */}
                <div className="relative flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl flex items-center justify-center group-hover:from-blue-200 group-hover:to-blue-300 transition-all duration-200">
                        <span className="text-lg font-bold text-blue-700">
                          {index + 1 + (currentPage - 1) * itemsPerPage}
                        </span>
                      </div>
                      <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-700 transition-colors duration-200">
                        {project.project_name}
                      </h3>
                      <div className="w-0 group-hover:w-12 h-0.5 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-300 mt-1"></div>
                    </div>
                  </div>
                  <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>

                {/*Product Details */}
                <div className="relative mb-4 flex-grow">
                  <p className="text-sm text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-200">
                    {project.product_details || "No additional information available"}
                  </p>
                </div>

                {/* Customer Count */}
                <div className="relative mb-4">
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span className="text-sm text-gray-600 group-hover:text-gray-700 transition-colors duration-200">
                      {project.customer_count || 0} {(project.customer_count || 0) === 1 ? 'Customer' : 'Customers'}
                    </span>
                  </div>
                </div>

                {/*  Status and Actions */}
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full animate-pulse"></div>
                    <span className="text-xs text-gray-500 font-medium">Active Product</span>
                  </div>
                  <div className="flex items-center space-x-1 text-xs text-blue-600 font-medium opacity-0 group-hover:opacity-100 transition-all duration-200">
                    <span>View Details</span>
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                </div>

                {/*  Hover Glow Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-600/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            ))}
          </div>

        ) : (
          /*Empty State */
          <div className="text-center py-16 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200/60 shadow-sm">
            <div className="max-w-md mx-auto">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center">
                <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">No products found</h3>
              <p className="text-gray-500 mb-8 leading-relaxed">Get started by creating your first product configuration to unlock powerful features.</p>
              <button
                onClick={() => { window.location.href = '/OliConfigurator'; }}
                className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Create Your First Product
              </button>
            </div>
          </div>
        )}

        {/* Pagination */}
        <div className="mt-8 flex items-center justify-between bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-gray-200/60">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            className="inline-flex items-center px-4 py-2 border border-gray-300/60 text-sm font-medium rounded-lg text-gray-700 bg-white/80 hover:bg-white hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 backdrop-blur-sm"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Previous
          </button>

          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-700 font-medium">
              Page <span className="font-bold text-blue-600">{currentPage}</span> of{" "}
              <span className="font-bold text-blue-600">{totalPages}</span>
            </span>
            <div className="flex items-center space-x-1">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                const page = i + 1;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-2 h-2 rounded-full transition-all duration-200 ${currentPage === page
                        ? 'bg-blue-600 w-6'
                        : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                  />
                );
              })}
            </div>
          </div>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            className="inline-flex items-center px-4 py-2 border border-gray-300/60 text-sm font-medium rounded-lg text-gray-700 bg-white/80 hover:bg-white hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 backdrop-blur-sm"
          >
            Next
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </main>

      {/*  Loading Overlay */}
      {loading && (
        <div className="fixed inset-0 z-50 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-2xl p-8 flex items-center space-x-4 shadow-2xl border border-gray-200/60">
            <div className="relative">
              <svg className="animate-spin h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              <div className="absolute inset-0 rounded-full bg-blue-600/20 animate-ping"></div>
            </div>
            <div>
              <span className="text-gray-700 font-semibold text-lg">Loading Products</span>
              <p className="text-gray-500 text-sm">Fetching customer data...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OliProductSelectionPage;

